/** @format */

import { Article } from './article.interface';
import { ArticleSearchV2Request } from './article-search-v2-request.interface';

/**
 * https://github.com/dsg-tech/mtools-article-search/blob/main/src/main/java/com/dsg/mtools/article/search/model/Response.java
 */
export interface ArticleSearchV2Response {
  resultsFound: number;
  responseList: Article[];
  requestContext: ArticleSearchV2Request;
  // values are the elasticsearch class `SearchProfileShardResult` but that class is complex and not relevant to our use case
  profile: Record<string, unknown>;
}
